import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { SIGNATURE_PICKS } from "../data/menu";

export const SignaturePicks = () => {
  return (
    <section
      id="signature"
      data-testid="signature-picks-section"
      className="relative py-24 md:py-32 bg-espresso text-cream overflow-hidden"
    >
      {/* decorative gold rings */}
      <div className="pointer-events-none absolute -top-32 -right-24 w-[420px] h-[420px] rounded-full border border-gold/15" aria-hidden="true" />
      <div className="pointer-events-none absolute -bottom-40 -left-20 w-[520px] h-[520px] rounded-full border border-gold/10" aria-hidden="true" />
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[1px] bg-gold/10" aria-hidden="true" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="inline-flex items-center gap-3 text-gold text-[12px] tracking-[0.3em] uppercase mb-5">
              <Sparkles size={14} />
              Customer Favourites
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-cream text-balance">
              The signatures, <span className="italic text-gold">on repeat.</span>
            </h2>
          </div>
          <p className="max-w-sm text-cream/70 text-[14px] leading-[1.8]">
            The five orders our regulars rarely change. If it's your first
            visit, start here.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-gold/30">
          {SIGNATURE_PICKS.map((pick, i) => (
            <motion.div
              key={pick.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group bg-espresso p-8 lg:p-10 min-h-[280px] flex flex-col justify-between hover:bg-[#2A1E1A] transition-colors duration-500"
              data-testid={`signature-pick-${i}`}
            >
              <span className="font-script text-3xl text-gold">
                0{i + 1}
              </span>
              <div>
                <h3 className="font-serif text-2xl lg:text-[26px] leading-tight text-cream">
                  {pick.name}
                </h3>
                <p className="mt-3 text-[13px] text-cream/65 leading-[1.7]">
                  {pick.note}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#menu"
            data-testid="signature-cta-full-menu"
            className="inline-flex items-center gap-3 border border-gold text-gold px-8 py-4 text-[12px] tracking-[0.28em] uppercase hover:bg-gold hover:text-espresso transition-colors duration-500"
          >
            Explore the full menu
          </a>
        </div>
      </div>
    </section>
  );
};
